/* Reusable Visual Quiz Builder trigger
 * Usage:
 * <button data-vqb-open data-vqb-quiz-id="1">Take the quiz</button>
 * Optional:
 * - data-vqb-slide="0"
 * - data-vqb-popup="true" (default true)
 */
(function() {
  var sizingAttempts = 0;
  var sizingInterval = null;

  function toBool(value, defaultValue) {
    if (value === undefined || value === null || value === '') return defaultValue;
    return String(value).toLowerCase() === 'true';
  }

  function parseNumber(value, fallback) {
    var n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function buildHash(quizId, slide, popup) {
    // VQB hash parser format on site:
    // finder-quiz-{quizId}-{activeSlide}-{isFullScreenPopup}
    return 'finder-quiz-' + quizId + '-' + slide + '-' + (popup ? 1 : 0);
  }

  function openViaFinderQuiz(quizId, slide, popup) {
    if (!window.FinderQuiz || typeof window.FinderQuiz.open !== 'function') {
      return false;
    }
    window.FinderQuiz.open(quizId, slide, popup);
    return true;
  }

  function openQuizFromElement(el) {
    var quizId = parseNumber(el.getAttribute('data-vqb-quiz-id'), 0);
    var slide = parseNumber(el.getAttribute('data-vqb-slide'), 0);
    var popup = toBool(el.getAttribute('data-vqb-popup'), true);

    if (!quizId) return;

    // Preferred: call VQB global API directly
    if (openViaFinderQuiz(quizId, slide, popup)) return;

    // Fallback: use hash format that VQB listens for
    var hash = buildHash(quizId, slide, popup);
    if (window.location.hash === '#' + hash) {
      // Force hashchange for repeated opens on same page
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    window.location.hash = hash;
  }

  function setPopupSizing() {
    var root = document.documentElement;
    root.style.setProperty('--desktop-popup-height', '82%');
    root.style.setProperty('--desktop-popup-height-vh', '82vh');
    root.style.setProperty('--tablet-popup-height', '84%');
    root.style.setProperty('--tablet-popup-height-vh', '84vh');
    root.style.setProperty('--mobile-popup-height', '88%');
    root.style.setProperty('--mobile-popup-height-vh', '88vh');

    document.querySelectorAll('.whai-quiz-container.whai-popup .whai-quiz').forEach(function(el) {
      var h = window.innerWidth >= 1025 ? '82%' : (window.innerWidth >= 769 ? '84%' : '88%');
      el.style.setProperty('height', h, 'important');
    });

    document.querySelectorAll('.whai-quiz-container.whai-popup .whai-quiz .whai-quiz-inner').forEach(function(el) {
      var h = window.innerWidth >= 1025 ? '82vh' : (window.innerWidth >= 769 ? '84vh' : '88vh');
      el.style.setProperty('height', h, 'important');
    });
  }

  function startSizingEnforcement() {
    sizingAttempts = 0;
    if (sizingInterval) {
      clearInterval(sizingInterval);
    }
    sizingInterval = setInterval(function() {
      setPopupSizing();
      sizingAttempts += 1;
      // Keep enforcing briefly while VQB bootstraps and mutates styles
      if (sizingAttempts > 30) {
        clearInterval(sizingInterval);
        sizingInterval = null;
      }
    }, 120);
  }

  function isQuizVisible() {
    return !!document.querySelector('.whai-quiz-container.whai-popup.visible, .whai-quiz-container.visible');
  }

  function closeQuiz() {
    if (typeof window.closeQuizButton === 'function') {
      try {
        window.closeQuizButton();
        return;
      } catch (e) {
        // continue to fallback
      }
    }

    // Fallback: clear hash used by VQB fullscreen/popup routing
    if (window.location.hash && window.location.hash.indexOf('#finder-quiz-') === 0) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  function onTriggerClick(evt) {
    var trigger = evt.target.closest('[data-vqb-open]');
    if (!trigger) return;
    evt.preventDefault();
    startSizingEnforcement();
    openQuizFromElement(trigger);
  }

  function onEscapeClose(evt) {
    if (evt.key !== 'Escape') return;
    if (!isQuizVisible()) return;
    closeQuiz();
  }

  function onBackdropClose(evt) {
    var container = evt.target.closest('.whai-quiz-container.whai-popup.visible');
    if (!container) return;
    if (evt.target.closest('.whai-quiz')) return;
    closeQuiz();
  }

  document.addEventListener('click', onTriggerClick);
  document.addEventListener('keydown', onEscapeClose);
  document.addEventListener('click', onBackdropClose);
  window.addEventListener('resize', setPopupSizing);
})();
